/* =========================================================
   ApexMane — Animation Engine
   ========================================================= */
(function() {
  'use strict';

  const APEX = window.APEX = window.APEX || {};

  // ---------- 1. Page loader (DISABLED for performance) ----------
  document.documentElement.classList.add('apex-js-ready');
  // Loader removed — make sure body never gets apex-loading class
  if (document.body) {
    document.body.classList.remove('apex-loading');
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      document.body && document.body.classList.remove('apex-loading');
    });
  }
  // Remove any leftover .apex-loader element if present
  document.addEventListener('DOMContentLoaded', function () {
    var leftoverLoader = document.querySelector('.apex-loader');
    if (leftoverLoader && leftoverLoader.parentNode) {
      leftoverLoader.parentNode.removeChild(leftoverLoader);
    }
  });

  // ---------- 2. IntersectionObserver scroll reveals ----------
  function setupReveals() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.apex-reveal, .apex-reveal-child, .apex-reveal--scale, .apex-reveal--left, .apex-reveal--right, .apex-img-reveal').forEach(el => el.classList.add('is-visible'));
      document.querySelectorAll('.shopify-section[id*="apex"]').forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible', 'is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll(
      '.apex-reveal, .apex-reveal-child, .apex-reveal--scale, .apex-reveal--left, .apex-reveal--right, .apex-img-reveal, .shopify-section[id*="apex"]'
    ).forEach(el => io.observe(el));
  }

  // ---------- 3. Count-up animation for stats ----------
  function countUp(el) {
    const raw = el.textContent.trim();
    const match = raw.match(/^([\d,]+(?:\.\d+)?)(.*)$/);
    if (!match) return;
    const target = parseFloat(match[1].replace(/,/g, ''));
    const suffix = match[2] || '';
    if (isNaN(target)) return;
    const duration = 1600;
    const start = performance.now();
    const isInt = Number.isInteger(target);

    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 4);
      const value = target * eased;
      el.textContent = (isInt ? Math.round(value).toLocaleString() : value.toFixed(1)) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function setupCountUps() {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          countUp(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.apex-stat__num, [data-apex-countup]').forEach(el => io.observe(el));
  }

  // ---------- 4. Top scroll progress bar ----------
  function setupScrollBar() {
    let bar = document.querySelector('.apex-scroll-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'apex-scroll-bar';
      document.body.appendChild(bar);
    }
    let ticking = false;
    function update() {
      const scrolled = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (scrolled / max) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ---------- 5. Header scroll-shrink ----------
  function setupHeaderScroll() {
    const header = document.querySelector('.shopify-section-header');
    if (!header) return;
    let ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ---------- 6. Cart helpers ----------
  APEX.openCartDrawer = function() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  };

  APEX.refreshCartSections = async function() {
    try {
      const drawer = document.querySelector('cart-drawer');
      const bubbleEl = document.getElementById('cart-icon-bubble');
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      const secRes = await fetch('/?sections=' + sectionIds.join(','), { credentials: 'same-origin' });
      const sections = await secRes.json();
      // Render cart drawer
      if (drawer && sections['cart-drawer']) {
        const drawerEl = document.getElementById('CartDrawer');
        if (drawerEl) {
          const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newInner = parsed.querySelector('#CartDrawer');
          if (newInner) drawerEl.innerHTML = newInner.innerHTML;
        }
        if (drawer.classList.contains('is-empty') && cart.item_count > 0) {
          drawer.classList.remove('is-empty');
        }
      }
      // Render cart icon bubble
      if (bubbleEl && sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsed.querySelector('#cart-icon-bubble');
        if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
      }
      return cart;
    } catch (e) {
      console.warn('[ApexMane] refresh failed', e);
      return null;
    }
  };

  // ---------- 7. Rich Add-to-Cart Popup ----------
  function ensurePopupNode() {
    let pop = document.querySelector('.apex-atc-popup');
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'apex-atc-popup';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', 'Item added to cart');
    pop.innerHTML = `
      <div class="apex-atc-popup__head">
        <div class="apex-atc-popup__head-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><path d="M5 12l4 4 10-10"/></svg>
          <span>Added to cart</span>
        </div>
        <button class="apex-atc-popup__close" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        </button>
      </div>
      <div class="apex-atc-popup__body">
        <div class="apex-atc-popup__img"></div>
        <div class="apex-atc-popup__info">
          <h3 class="apex-atc-popup__name"></h3>
          <p class="apex-atc-popup__variant"></p>
          <div class="apex-atc-popup__price"></div>
        </div>
      </div>
      <div class="apex-atc-popup__urgency">
        <span class="apex-atc-popup__urgency-item">
          <span class="apex-atc-popup__pulse"></span>
          <strong data-apex-viewers>30</strong>&nbsp;viewing now
        </span>
        <span class="apex-atc-popup__urgency-sep"></span>
        <span class="apex-atc-popup__urgency-item">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>
          Reserved <strong data-apex-cart-timer>15:00</strong>
        </span>
      </div>
      <div class="apex-atc-popup__trust">
        <span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z"/></svg> 90-Day Money-Back Guarantee</span>
      </div>
      <div class="apex-atc-popup__cart-meta">
        <span><strong class="apex-atc-popup__count">0</strong> items in cart</span>
        <span class="apex-atc-popup__total">$0.00</span>
      </div>
      <div class="apex-atc-popup__actions">
        <button type="button" class="apex-atc-popup__btn apex-atc-popup__btn--secondary" data-apex-view-cart>View Cart</button>
        <a class="apex-atc-popup__btn apex-atc-popup__btn--primary" href="/checkout">Checkout
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 7h12m0 0L8 2m5 5L8 12" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        </a>
      </div>
    `;
    document.body.appendChild(pop);

    pop.querySelector('.apex-atc-popup__close').addEventListener('click', () => APEX.closePopup());
    pop.querySelector('[data-apex-view-cart]').addEventListener('click', () => {
      APEX.closePopup();
      APEX.openCartDrawer();
    });
    return pop;
  }

  let popupTimer = null;
  APEX.closePopup = function() {
    const pop = document.querySelector('.apex-atc-popup');
    if (pop) pop.classList.remove('is-visible');
    if (popupTimer) { clearTimeout(popupTimer); popupTimer = null; }
  };

  APEX.showPopup = function(payload) {
    const pop = ensurePopupNode();
    const imgWrap = pop.querySelector('.apex-atc-popup__img');
    const name = pop.querySelector('.apex-atc-popup__name');
    const variant = pop.querySelector('.apex-atc-popup__variant');
    const price = pop.querySelector('.apex-atc-popup__price');
    const countEl = pop.querySelector('.apex-atc-popup__count');
    const totalEl = pop.querySelector('.apex-atc-popup__total');

    imgWrap.innerHTML = payload.image
      ? `<img src="${payload.image}" alt="">`
      : '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="color:#3AACB0"><path d="M3 5h2l2 9h11l2-7H6"/></svg>';
    name.textContent = payload.title || 'Item';
    variant.textContent = payload.variantTitle && payload.variantTitle !== 'Default Title' ? payload.variantTitle : '';
    price.textContent = payload.price || '';
    countEl.textContent = payload.itemCount != null ? payload.itemCount : '';
    totalEl.textContent = payload.total || '';

    requestAnimationFrame(() => pop.classList.add('is-visible'));
    if (popupTimer) clearTimeout(popupTimer);
    popupTimer = setTimeout(() => APEX.closePopup(), 8000);
  };

  function formatMoney(cents) {
    if (window.Shopify && Shopify.currency) {
      const amount = (cents / 100).toFixed(2);
      return amount + ' ' + Shopify.currency.active;
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ---------- 8. Override ATC: AJAX submit + popup, no auto-drawer ----------
  function attachAtcHandler() {
    document.querySelectorAll('product-form form, form[action*="/cart/add"]').forEach(form => {
      if (form.dataset.apexBound) return;
      form.dataset.apexBound = 'true';

      form.addEventListener('submit', async function(e) {
        // Only intercept if we're on a real product form
        const submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn || submitBtn.disabled) return;

        e.preventDefault();
        e.stopPropagation();

        // Spinner / button state
        submitBtn.classList.add('loading');
        const spinner = form.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        const inner = submitBtn.querySelector('.apex-ph-atc__inner');
        if (inner) inner.style.opacity = '0.4';
        submitBtn.setAttribute('aria-busy', 'true');

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: formData
          });
          const json = await res.json();
          if (json.status && json.status >= 400) {
            throw new Error(json.message || json.description || 'Add to cart failed');
          }

          // Refresh sections so cart drawer + bubble are up-to-date
          const cart = await APEX.refreshCartSections();

          // Show rich popup
          APEX.showPopup({
            image: json.featured_image && json.featured_image.url
              ? json.featured_image.url
              : (json.image || ''),
            title: json.product_title || json.title || 'Item',
            variantTitle: json.variant_title || '',
            price: formatMoney(json.final_line_price || json.price || 0),
            itemCount: cart ? cart.item_count : '',
            total: cart ? formatMoney(cart.total_price) : ''
          });

          // Pulse ATC button
          submitBtn.classList.add('is-added');
          setTimeout(() => submitBtn.classList.remove('is-added'), 1800);

          // Publish Dawn cartUpdate so other listeners (gift logic) fire
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'apex-atc',
              productVariantId: formData.get('id'),
              cartData: json
            });
          }
        } catch (err) {
          console.error('[ApexMane] ATC error:', err);
          const errBox = form.querySelector('.product-form__error-message-wrapper');
          if (errBox) {
            errBox.removeAttribute('hidden');
            const msg = errBox.querySelector('.product-form__error-message');
            if (msg) msg.textContent = err.message || 'Sorry, this item could not be added.';
          }
        } finally {
          submitBtn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          if (inner) inner.style.opacity = '';
          submitBtn.removeAttribute('aria-busy');
        }
      }, true);
    });
  }

  // ---------- 8. Smooth in-page anchor scroll with offset ----------
  function setupAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id) || document.querySelector(`[id="${id}"]`);
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector('.shopify-section-header');
      const offset = header ? header.offsetHeight + 12 : 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });
  }

  // ---------- 9. Magnetic cursor on big buttons ----------
  function setupMagnetic() {
    const buttons = document.querySelectorAll('.apex-ph-atc, .apex-cta-' + (document.querySelector('[class*="apex-cta-"]') ? '' : '__btn'));
    document.querySelectorAll('.apex-ph-atc, [class*="apex-cta-"][class*="__btn"], [class*="apex-grt-"][class*="__btn"], [class*="apex-out-"][class*="__btn"]').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const mx = e.clientX - r.left - r.width / 2;
        const my = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${mx * 0.08}px, ${my * 0.18}px) translateY(-2px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  // ---------- 10. Mobile sticky ATC bar (product page only) ----------
  function setupMobileStickyAtc() {
    if (window.innerWidth > 750) return;
    const productHero = document.querySelector('[class*="apex-ph-"]');
    if (!productHero) return;
    const mainAtc = productHero.querySelector('.apex-ph-atc');
    if (!mainAtc) return;

    const bar = document.createElement('div');
    bar.className = 'apex-mobile-sticky-atc';
    bar.innerHTML = `
      <div class="apex-mobile-sticky-atc__price">
        <small>Total</small>
        <span data-apex-mobile-price>${productHero.querySelector('[data-apex-price]')?.textContent || ''}</span>
      </div>
      <button type="button" class="apex-mobile-sticky-atc__btn" data-apex-mobile-atc>
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none"><path d="M3 5h2l2 9h9l2-7H6" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        ADD TO CART
      </button>
    `;
    document.body.appendChild(bar);

    // Sync price when variant changes
    const priceEl = productHero.querySelector('[data-apex-price]');
    if (priceEl) {
      const obs = new MutationObserver(() => {
        const out = bar.querySelector('[data-apex-mobile-price]');
        if (out) out.textContent = priceEl.textContent;
      });
      obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Click triggers main ATC
    bar.querySelector('[data-apex-mobile-atc]').addEventListener('click', () => {
      mainAtc.click();
    });

    // Show/hide based on scroll past hero
    const heroBottom = () => {
      const r = productHero.getBoundingClientRect();
      return r.bottom < 200; // hero scrolled mostly out
    };
    function update() {
      bar.classList.toggle('is-visible', heroBottom());
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ---------- 10c. Cart Urgency: live viewers + reservation timer ----------
  function setupCartUrgency() {
    const RESERVE_KEY = 'apex_cart_reserve_until';
    const RESERVE_MINUTES = 15;
    const VIEWER_KEY = 'apex_cart_viewers';

    function getReserveUntil() {
      const stored = parseInt(sessionStorage.getItem(RESERVE_KEY), 10);
      if (stored && stored > Date.now()) return stored;
      const fresh = Date.now() + RESERVE_MINUTES * 60 * 1000;
      sessionStorage.setItem(RESERVE_KEY, String(fresh));
      return fresh;
    }

    function getViewerBase() {
      let n = parseInt(sessionStorage.getItem(VIEWER_KEY), 10);
      if (!n || n < 18 || n > 86) {
        n = 24 + Math.floor(Math.random() * 38); // 24..61
        sessionStorage.setItem(VIEWER_KEY, String(n));
      }
      return n;
    }

    function tickTimer() {
      const els = document.querySelectorAll('[data-apex-cart-timer]');
      if (!els.length) return;
      const until = getReserveUntil();
      let remain = Math.max(0, until - Date.now());
      if (remain === 0) {
        // Reset to fresh 15:00 when expired (keeps the urgency feel without breaking flow)
        sessionStorage.removeItem(RESERVE_KEY);
        remain = RESERVE_MINUTES * 60 * 1000;
        sessionStorage.setItem(RESERVE_KEY, String(Date.now() + remain));
      }
      const totalSec = Math.floor(remain / 1000);
      const m = Math.floor(totalSec / 60);
      const s = totalSec % 60;
      const text = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      els.forEach(el => { el.textContent = text; });
    }

    function tickViewers() {
      const els = document.querySelectorAll('[data-apex-viewers]');
      if (!els.length) return;
      const base = getViewerBase();
      // tiny random drift +/- 2
      const drift = Math.floor(Math.random() * 5) - 2;
      const value = Math.max(18, Math.min(86, base + drift));
      els.forEach(el => { el.textContent = value; });
    }

    tickTimer(); tickViewers();
    setInterval(tickTimer, 1000);
    setInterval(tickViewers, 7000);
    // NOTE: previously had a MutationObserver here but it created an infinite
    // feedback loop (tick modifies DOM → observer fires → tick modifies DOM…).
    // The 1s setInterval already re-queries the DOM, so swapped-in cart HTML
    // gets picked up on the next tick automatically.
  }

  // ---------- 11. Init ----------
  function init() {
    setupReveals();
    setupCountUps();
    setupScrollBar();
    setupHeaderScroll();
    setupAnchors();
    attachAtcHandler();
    setupMobileStickyAtc();
    setupCartUrgency();
    // Magnetic only on devices with hover
    if (window.matchMedia('(hover: hover)').matches) setupMagnetic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
